module.exports = __webpack_public_path__ + "img/shebei@2x.98498883.png";